import {
  getDefaultEmailTemplate,
  renderPlaceholdersInTemplates
} from 'shared-helpers/email';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import {
  PathAccessGroups,
  PathAccessSettings,
  PathAccessUsers,
  PathPage
} from '.';

import type { GetEmailTemplatesByTypeRes } from 'shared-types/responses';

const PathAccess = () => {
  const {
    language,
    pageState: { path },
    serverConfig: { adminUrl },
    user
  } = useReduxState();

  const { data: emailTemplatesData } = useApiData<GetEmailTemplatesByTypeRes>({
    url: `/admin/email-templates-data?type=path-invite&pathId=${path.id}`
  });

  let emailTemplates = emailTemplatesData?.emailTemplates || [];

  emailTemplates = renderPlaceholdersInTemplates({
    emailTemplates,
    overridePlaceholderValues: {
      contactEmail: user?.email,
      pathTitle: path?.title,
      pathUrl: `${adminUrl}/paths/${path?.id}`
    }
  });

  const emailTemplatesDefault = getDefaultEmailTemplate({
    language,
    emailTemplates
  });

  return (
    <div className="access">
      <div className="users">
        <div className="section">
          <PathAccessSettings />
        </div>
        <div className="section">
          <PathAccessUsers
            emailTemplates={emailTemplates}
            emailTemplatesDefault={emailTemplatesDefault}
          />
        </div>
        <div className="section">
          <PathAccessGroups
            emailTemplates={emailTemplates}
            emailTemplatesDefault={emailTemplatesDefault}
          />
        </div>

        <style jsx>{`
          .section:not(:first-child) {
            margin-top: 40px;
          }
        `}</style>
      </div>
    </div>
  );
};

export default PathAccess;
